import { mount } from 'enzyme';
import * as React from 'react';

import { Radiobutton } from './radiobutton';

describe('radio button', () => {
  test('should match snapshot and styles for default props', () => {
    expect(
      mount(
        <Radiobutton name={'risk-tolerance'} value={1} isChecked={true}>
          {'Moderately Conservative'}
        </Radiobutton>,
      ),
    ).toMatchSnapshot();
  });

  //   test('should match snapshot with label', () => {
  //     expect(mount(<Button text={'click'} name="button1" />)).toMatchSnapshot();
  //   });

  //   test('should match snapshot with disabled', () => {
  //     expect(
  //       mount(<Button text={'click'} name="button1" disabled={true} />),
  //     ).toMatchSnapshot();
  //   });

  //   test('With ellipsis', () => {
  //     expect(
  //       mount(<Button text={'click'} name={'button1'} ellipsis={true} />),
  //     ).toMatchSnapshot();
  //   });
});
